import { graphql } from "gatsby"

export const query = graphql`
  fragment EventCard on WpEvent {
    title
    uri
    date(formatString: "D MMMM YYYY")
    excerpt
    featuredImage {
      node {
        altText
        localFile {
          childImageSharp {
            gatsbyImageData(width: 256)
          }
        }
      }
    }
    eventInfo: event {
      timeZone
      start {
        time
        date(formatString: "D MMMM YYYY")
      }
      end {
        date(formatString: "D MMMM YYYY")
        time
      }
    }
    categories {
      nodes {
        slug
        name
      }
    }
    nodeType
  }
`

export function getUnixTimestamp(date) {
  if (!date) return null;
  const dateObj = new Date(date);
  const unixTimestamp = Math.floor(dateObj.getTime() / 1000);
  return unixTimestamp;
}